import React, { useCallback, useEffect, useRef } from "react";

function Loader({
  logoText,
  progress,
  animate,
  isLoadedGame,
  onFinishedAnimation,
}) {
  const loaderRef = useRef(null);
  const logoWrapperRef = useRef(null);

  const handleLogoFinished = useCallback(() => {
    onFinishedAnimation();
  }, [onFinishedAnimation]);

  const handleWheel = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    const infoElement = loaderRef.current;
    if (infoElement) {
      infoElement.addEventListener("wheel", handleWheel, { passive: false });
      infoElement.addEventListener("touchmove", handleWheel, {
        passive: false,
      });
    }

    return () => {
      if (infoElement) {
        infoElement.removeEventListener("wheel", handleWheel);
        infoElement.removeEventListener("touchmove", handleWheel);
      }
    };
  }, [onFinishedAnimation]);

  useEffect(() => {
    if (isLoadedGame) {
      setTimeout(() => {
        handleLogoFinished();
      }, 500);
    }
  }, [isLoadedGame, handleLogoFinished]);

  useEffect(() => {
    const videoEl = document.getElementById("logoVideo");
    videoEl.setAttribute("playsinline", "");
    videoEl.setAttribute("autoplay", "");
    videoEl.setAttribute("muted", "");
    if (!videoEl) return;

    if (logoWrapperRef.current) {
      videoEl.style.display = "unset";
      logoWrapperRef.current.appendChild(videoEl);
    }
  }, [logoText]);

  return (
    <div id="loader-wrapper">
      <div id="loader" ref={loaderRef} style={{ opacity: animate ? 0 : 1 }}>
        <div id="wrapper">
          {logoText ? (
            <div className="logo-wrapper" ref={logoWrapperRef}>
              {/* video comes from index.html */}
            </div>
          ) : (
            <div className="logo-wrapper-svg">
              <svg width="50" height="50" id="logo">
                <circle
                  cx="25"
                  cy="25"
                  r="20"
                  stroke="#2803ff"
                  strokeWidth="5"
                  fill="transparent"
                />
              </svg>
            </div>
          )}
        </div>
        <div id="progress">
          <div id="inner" />
          <div id="outter" style={{ width: progress || "0" }} />
        </div>
      </div>
    </div>
  );
}

export default React.memo(Loader);
